import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import {
  seedBatchesApi,
  type CreateSeedBatchRequest,
} from "../services/seedBatchApi";

export const useCreateSeedBatch = () => {
  return useMutation({
    mutationFn: (payload: CreateSeedBatchRequest) =>
      seedBatchesApi.createSeedBatch(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["seed-batches"] });
      queryClient.invalidateQueries({ queryKey: ["seed-batches-by-order"] });
    },
  });
};

export const useSeedBatchesByOrder = (orderId?: string) => {
  return useQuery({
    queryKey: ["seed-batches-by-order", orderId],
    queryFn: () => seedBatchesApi.getByOrder(orderId!),
    enabled: !!orderId,
  });
};

export const useSeedBatchesByCustomer = (customerId?: string) => {
  return useQuery({
    queryKey: ["seed-batches-by-customer", customerId],
    queryFn: () => seedBatchesApi.getByCustomer(customerId!),
    enabled: !!customerId,
  });
};

export const useSeedBatch = (id?: string, enabled = true) => {
  return useQuery({
    queryKey: ["seed-batch", id],
    queryFn: () => seedBatchesApi.getSeedBatchById(id!),
    enabled: !!id && enabled,
  });
};